<template>
  <div class="modal-card ns-edit-space">
    <PassGate :session="session" @logout="onLogout" :spaceID="spaceID">
      <div>

        <b-tabs v-model="activeTab">
          <!-- EDIT -->
            <b-tab-item label="Edit">
              <textarea class="textarea ns-content-edit" v-model="spaceObj.content" @input="saving = true; updateContent()"></textarea>
              <p v-if="saving">Saving to Cloud... </p>
              <p v-if="err">{{ err }}</p>
            </b-tab-item>

          <!-- CH PASSWORD -->
            <b-tab-item label="Change Password">
              <h1>
                Change Password
              </h1>
              <form @submit.prevent="updatePW()">
                <p>
                  Existing Password
                </p>
                <div>
                  <input class="input" autocomplete="passgate-of-spaceID"  type="password" v-model="chpw.nowPW">
                </div>
                <p>New Password</p>
                <div>
                  <input class="input" autocomplete="newpassword" type="password" v-model="chpw.newPW">
                </div>
                <p>Submit</p>
                <div class="field">
                  <div class="control">
                    <input type="submit" class="button is-primary" value="Submit">
                  </div>
                </div>
                <p v-if="saving">Saving to Cloud... </p>
                <p v-if="err">{{ err }}</p>
              </form>
            </b-tab-item>
        </b-tabs>
      </div>
    </PassGate>
  </div>
</template>

<script>
import * as API from '../../network/api'
import _ from 'lodash'

let DB = {}
window.lokStorage = {
  getItem (k) {
    return DB[k] || null
  },
  setItem (k, v) {
    DB[k] = v
    return DB[k]
  }
}

export default {
  components: {
    PassGate: () => import('./PassGate.vue')
  },
  props: {
    spaceObj: {},
    spaceID: {}
  },
  data () {
    let session = {
      get password () {
        return window.lokStorage.getItem('sess-' + this.spaceID + 'pw')
      },
      set password (v) {
        return window.lokStorage.setItem('sess-' + this.spaceID + 'pw', v) || false
      }
    }
    return {
      session,
      err: '',
      saving: false,
      chpw: {
        nowPW: '',
        newPW: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    onLogout () {
      this.session.password = ''
    },
    updateContent: _.debounce(async function () {
      this.err = ''
      this.saving = true
      await API.updateSpaceIDContent({ spaceID: this.spaceID, password: this.session.password, content: this.spaceObj.content })
      this.saving = false
    }, 300),
    async updatePW () {
      this.err = ''
      this.saving = true
      try {
        await API.changePassword({ spaceID: this.spaceID, password: this.chpw.nowPW, newPassword: this.chpw.newPW })
        this.session.password = this.chpw.newPW
        this.chpw = {
          nowPW: '',
          newPW: ''
        }
        alert('password successfully chnaged!')
      } catch (e) {
        this.err = e.message
      }
      this.saving = false
    }
  }
}
</script>

<style>

</style>
